import {
  MoneyCollectOutlined,
  PlusOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingOutlined
} from '@ant-design/icons';
import { Menu } from 'antd';
import SubMenu from 'antd/lib/menu/SubMenu';
import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink, useLocation } from 'react-router-dom';
import { SETTING_KEYS, UI_ROUTES } from '../../../shared/utils/constants';

const MenuList = (): ReactElement => {
  const location = useLocation();

  return (
    <Menu theme="dark" mode="inline" selectedKeys={[location.pathname]}>
      <Menu.Item key={UI_ROUTES.ORDERS} icon={<ShoppingOutlined />}>
        <NavLink to={UI_ROUTES.ORDERS}>
          <FormattedMessage id={UI_ROUTES.ORDERS} />
        </NavLink>
      </Menu.Item>
      <Menu.Item key={UI_ROUTES.BILLING} icon={<ShopOutlined />}>
        <NavLink to={UI_ROUTES.BILLING}>
          <FormattedMessage id={UI_ROUTES.BILLING} />
        </NavLink>
      </Menu.Item>
      <Menu.Item key={UI_ROUTES.SEARCHORDER} icon={<MoneyCollectOutlined />}>
        <NavLink to={UI_ROUTES.SEARCHORDER}>
          <FormattedMessage id={UI_ROUTES.SEARCHORDER} />
        </NavLink>
      </Menu.Item>
      <SubMenu
        key={UI_ROUTES.ORDERSCREATE}
        title={<FormattedMessage id={UI_ROUTES.ORDERSCREATE} />}
        icon={<PlusOutlined />}
      >
        <Menu.Item key={UI_ROUTES.CREATEORDER} icon={<MoneyCollectOutlined />}>
          <NavLink to={UI_ROUTES.CREATEORDER}>
            <FormattedMessage id={UI_ROUTES.CREATEORDER} />
          </NavLink>
        </Menu.Item>
        <Menu.Item key={UI_ROUTES.BATCHORDER} icon={<MoneyCollectOutlined />}>
          <NavLink to={UI_ROUTES.BATCHORDER}>
            <FormattedMessage id={UI_ROUTES.BATCHORDER} />
          </NavLink>
        </Menu.Item>
      </SubMenu>
      <SubMenu
        key={UI_ROUTES.PRICECHECK}
        title={<FormattedMessage id={UI_ROUTES.PRICECHECK} />}
        icon={<PlusOutlined />}
      >
        <Menu.Item key={UI_ROUTES.RATE} icon={<MoneyCollectOutlined />}>
          <NavLink to={UI_ROUTES.RATE}>
            <FormattedMessage id={UI_ROUTES.RATE} />
          </NavLink>
        </Menu.Item>
        <Menu.Item key={UI_ROUTES.PRICE} icon={<MoneyCollectOutlined />}>
          <NavLink to={UI_ROUTES.PRICE}>
            <FormattedMessage id={UI_ROUTES.PRICE} />
          </NavLink>
        </Menu.Item>
      </SubMenu>
      <Menu.Item key={UI_ROUTES.CARDDELIVERY} icon={<MoneyCollectOutlined />}>
        <NavLink to={UI_ROUTES.CARDDELIVERY}>
          <FormattedMessage id={UI_ROUTES.CARDDELIVERY} />
        </NavLink>
      </Menu.Item>
      <SubMenu
        key={UI_ROUTES.SETTINGS}
        title={<FormattedMessage id={UI_ROUTES.SETTINGS} />}
        icon={<SettingOutlined />}
      >
        {SETTING_KEYS.map((key) => {
          return (
            <Menu.Item key={key}>
              <NavLink to={key}>
                <FormattedMessage id={key} />
              </NavLink>
            </Menu.Item>
          );
        })}
      </SubMenu>
    </Menu>
  );
};

export default MenuList;
